export const newColorsRassvet = {
  brown: '#581728',
  brown30: '#CAB5BE',
  brown75: '#836077',
  pink: '#E65100',
  backgroundPrimary: 'linear-gradient(180deg, #FFF5F0 0%, #FEEADD 78.65%, #FFDAC3 100%)',
  white: '#FFFFFF',
};